import { render, staticRenderFns } from "./form-footer.component.vue?vue&type=template&id=42d765ee&scoped=true&"
import script from "./form-footer.component.vue?vue&type=script&lang=ts&"
export * from "./form-footer.component.vue?vue&type=script&lang=ts&"
import style0 from "./form-footer.component.vue?vue&type=style&index=0&id=42d765ee&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42d765ee",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
